import React, { useState, useEffect } from 'react';

const API = process.env.REACT_APP_API_URL || 'https://bot.devit.es/api';

function getToken() { return localStorage.getItem('devit_token'); }
function authHeaders() { return { 'Content-Type': 'application/json', authorization: `Bearer ${getToken()}` }; }

function Badge({ color, children }) {
  const colors = {
    green: { background: '#0a2a14', color: '#4ade80', border: '1px solid #1a4a24' },
    gray:  { background: '#1a1c2e', color: '#5a5e82', border: '1px solid #2a2e4a' },
    purple:{ background: '#16132a', color: '#a78bfa', border: '1px solid #3a2a6a' },
  };
  return (
    <span style={{ fontSize: 11, fontWeight: 700, borderRadius: 4, padding: '2px 8px', ...colors[color] }}>
      {children}
    </span>
  );
}

function Card({ children, style }) {
  return (
    <div style={{ background: '#12141f', border: '1px solid #1e2035', borderRadius: 10,
                  padding: 22, ...style }}>
      {children}
    </div>
  );
}

export default function Academia() {
  const [equipo, setEquipo]     = useState([]);
  const [loading, setLoading]   = useState(true);
  const [modal, setModal]       = useState(false);
  const [form, setForm]         = useState({ email: '', nombre_completo: '' });
  const [saving, setSaving]     = useState(false);
  const [msg, setMsg]           = useState(null);

  async function cargar() {
    setLoading(true);
    try {
      const r = await fetch(`${API}/academia/mi-equipo`, { headers: authHeaders() });
      if (r.ok) setEquipo(await r.json());
    } finally { setLoading(false); }
  }

  useEffect(() => { cargar(); }, []);

  async function invitar() {
    if (!form.email || !form.nombre_completo) {
      setMsg({ type: 'err', text: 'Email y nombre son obligatorios' }); return;
    }
    setSaving(true); setMsg(null);
    const r = await fetch(`${API}/academia/invitar`, {
      method: 'POST', headers: authHeaders(),
      body: JSON.stringify(form),
    });
    if (r.ok) {
      setMsg({ type: 'ok', text: `✅ Invitación enviada a ${form.email}` });
      setForm({ email: '', nombre_completo: '' });
      cargar();
    } else {
      const d = await r.json();
      setMsg({ type: 'err', text: d.detail || 'Error enviando' });
    }
    setSaving(false);
  }

  async function eliminar(id, nombre) {
    if (!window.confirm(`¿Eliminar a ${nombre} del equipo?`)) return;
    await fetch(`${API}/academia/equipo/${id}`, { method: 'DELETE', headers: authHeaders() });
    cargar();
  }

  const completados = equipo.filter(e => e.certificado).length;

  return (
    <div style={{ padding: '28px 24px', maxWidth: 900 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
                    marginBottom: 24, flexWrap: 'wrap', gap: 16 }}>
        <div>
          <h1 style={{ color: '#f0f0ff', fontSize: 20, fontWeight: 800, marginBottom: 6 }}>
            🎓 Devit Academy — Cumplimiento Normativo
          </h1>
          <p style={{ color: '#5a5e82', fontSize: 13 }}>
            Forma a tu equipo en IA y cumple el Artículo 4 del EU AI Act.
            Cada empleado recibe un diploma con código de verificación.
          </p>
        </div>
        <button onClick={() => { setModal(true); setMsg(null); }}
          style={{ background: '#7c4dff', color: '#fff', border: 'none', borderRadius: 8,
                   padding: '10px 18px', cursor: 'pointer', fontSize: 13, fontWeight: 700,
                   whiteSpace: 'nowrap' }}>
          + Invitar empleado
        </button>
      </div>

      {/* Stats */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 14, marginBottom: 24 }}>
        {[
          { label: 'Empleados invitados', value: equipo.length, icon: '👥' },
          { label: 'Diplomas emitidos',   value: completados,   icon: '🎓' },
          { label: 'Pendientes',          value: equipo.length - completados, icon: '⏳' },
        ].map(s => (
          <Card key={s.label} style={{ padding: 16 }}>
            <div style={{ fontSize: 22, marginBottom: 6 }}>{s.icon}</div>
            <div style={{ fontSize: 26, fontWeight: 900, color: '#f0f0ff' }}>{s.value}</div>
            <div style={{ fontSize: 12, color: '#5a5e82', marginTop: 2 }}>{s.label}</div>
          </Card>
        ))}
      </div>

      {/* Info EU AI Act */}
      <Card style={{ marginBottom: 20, borderColor: '#2a2e4a' }}>
        <div style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
          <span style={{ fontSize: 24 }}>⚖️</span>
          <div>
            <div style={{ color: '#f0f0ff', fontWeight: 700, fontSize: 14, marginBottom: 4 }}>
              Artículo 4 — Reglamento (UE) 2024/1689 (AI Act)
            </div>
            <p style={{ color: '#5a5e82', fontSize: 13, lineHeight: 1.6, margin: 0 }}>
              Desde <strong style={{ color: '#9b9fc4' }}>febrero de 2025</strong> es obligatorio garantizar que
              las personas que trabajan con IA tienen la formación adecuada.
              Cada diploma emitido por Devit Academy incluye un <strong style={{ color: '#9b9fc4' }}>código QR verificable</strong> que
              acredita el cumplimiento ante inspecciones de la AESIA.
            </p>
            <div style={{ marginTop: 10 }}>
              <a href="/academia" target="_blank" rel="noreferrer"
                 style={{ color: '#7c4dff', fontSize: 12 }}>
                Ver el curso completo →
              </a>
            </div>
          </div>
        </div>
      </Card>

      {/* Tabla equipo */}
      <Card>
        <h3 style={{ color: '#f0f0ff', fontSize: 15, marginBottom: 16 }}>Mi equipo</h3>
        {loading ? (
          <p style={{ color: '#5a5e82', fontSize: 13 }}>Cargando...</p>
        ) : equipo.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '32px 0' }}>
            <div style={{ fontSize: 36, marginBottom: 12 }}>👥</div>
            <p style={{ color: '#5a5e82', fontSize: 14 }}>
              Aún no has invitado a nadie. Usa el botón "Invitar empleado" para enviar el curso por email.
            </p>
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ borderBottom: '1px solid #1e2035' }}>
                  {['Empleado', 'Progreso', 'Diploma', 'Acciones'].map(h => (
                    <th key={h} style={{ color: '#5a5e82', fontSize: 11, fontWeight: 700,
                                         textAlign: 'left', padding: '8px 12px' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {equipo.map(e => (
                  <tr key={e.id} style={{ borderBottom: '1px solid #1a1c2e' }}>
                    <td style={{ padding: '12px 12px', color: '#f0f0ff' }}>
                      <div style={{ fontWeight: 600 }}>{e.nombre_completo}</div>
                      <div style={{ color: '#5a5e82', fontSize: 12, marginTop: 2 }}>{e.email}</div>
                    </td>
                    <td style={{ padding: '12px 12px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <div style={{ flex: 1, background: '#1a1c2e', borderRadius: 4, height: 6, minWidth: 80 }}>
                          <div style={{
                            background: e.certificado ? '#16a34a' : '#7c4dff',
                            height: 6, borderRadius: 4,
                            width: `${Math.round((e.modulos_completados / e.total_modulos) * 100)}%`,
                          }} />
                        </div>
                        <span style={{ color: '#5a5e82', fontSize: 11, whiteSpace: 'nowrap' }}>
                          {e.modulos_completados}/{e.total_modulos}
                        </span>
                      </div>
                    </td>
                    <td style={{ padding: '12px 12px' }}>
                      {e.certificado ? (
                        <div>
                          <Badge color="green">✓ Emitido</Badge>
                          <div style={{ marginTop: 6, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                            <a href={`${API}/academia/certificado/${e.certificado}/pdf`}
                               download style={{ color: '#4ade80', fontSize: 11 }}>
                              ⬇ PDF
                            </a>
                            <a href={`/academia/verificar/${e.certificado}`}
                               target="_blank" rel="noreferrer" style={{ color: '#9b9fc4', fontSize: 11 }}>
                              🔍 Verificar
                            </a>
                          </div>
                        </div>
                      ) : (
                        <Badge color="gray">Pendiente</Badge>
                      )}
                    </td>
                    <td style={{ padding: '12px 12px' }}>
                      <button onClick={() => eliminar(e.id, e.nombre_completo)}
                        style={{ color: '#f87171', background: 'none', border: 'none',
                                 cursor: 'pointer', fontSize: 12 }}>
                        Eliminar
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>

      {/* Modal invitar */}
      {modal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.7)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#12141f', border: '1px solid #2a2e4a', borderRadius: 12,
                         padding: 28, width: '100%', maxWidth: 420 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 18 }}>
              <h3 style={{ color: '#f0f0ff', fontSize: 16 }}>Invitar empleado</h3>
              <button onClick={() => setModal(false)}
                style={{ background: 'none', border: 'none', color: '#5a5e82', cursor: 'pointer', fontSize: 20 }}>✕</button>
            </div>
            <p style={{ color: '#5a5e82', fontSize: 13, marginBottom: 18 }}>
              El empleado recibirá un email con su enlace personal de acceso al curso.
            </p>
            {[
              { label: 'Nombre completo *', key: 'nombre_completo', placeholder: 'Ej: Juan Martínez' },
              { label: 'Email *', key: 'email', placeholder: 'juan@tuempresa.com' },
            ].map(f => (
              <div key={f.key} style={{ marginBottom: 14 }}>
                <label style={{ display: 'block', fontSize: 12, color: '#9b9fc4', marginBottom: 5, fontWeight: 600 }}>
                  {f.label}
                </label>
                <input type="text" placeholder={f.placeholder} value={form[f.key]}
                  onChange={e => setForm(v => ({ ...v, [f.key]: e.target.value }))}
                  style={{ width: '100%', background: '#1a1c2e', border: '1px solid #2a2e4a',
                           borderRadius: 6, padding: '9px 12px', color: '#f0f0ff', fontSize: 14, boxSizing: 'border-box' }} />
              </div>
            ))}
            {msg && (
              <div style={{ fontSize: 13, marginBottom: 12,
                            color: msg.type === 'ok' ? '#4ade80' : '#f87171' }}>
                {msg.text}
              </div>
            )}
            <div style={{ display: 'flex', gap: 10, marginTop: 6 }}>
              <button onClick={() => setModal(false)}
                style={{ flex: 1, background: 'none', border: '1px solid #2a2e4a', borderRadius: 8,
                          color: '#9b9fc4', padding: '10px', cursor: 'pointer', fontSize: 13 }}>
                Cancelar
              </button>
              <button onClick={invitar} disabled={saving}
                style={{ flex: 2, background: '#7c4dff', color: '#fff', border: 'none',
                          borderRadius: 8, padding: '10px', cursor: 'pointer', fontSize: 13, fontWeight: 700 }}>
                {saving ? 'Enviando...' : '📨 Enviar invitación'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
